import { Directive, HostListener, OnDestroy, OnInit, input, output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

/**
 * Directive that adds a debounce functionality to the click event.
 */
@Directive({ selector: '[appDebounceClick]' })
export class DebounceClickDirective implements OnInit, OnDestroy {
  /**
   * The debounce time in milliseconds.
   */
  readonly debounceTime = input(300);

  /**
   * Event emitter for the debounced click event.
   */
  readonly debounceClick = output();

  private clicks = new Subject();
  private subscription!: Subscription;

  constructor() {}

  /**
   * Initializes the directive.
   */
  ngOnInit() {
    this.subscription = this.clicks
      .pipe(debounceTime(this.debounceTime()))
      .subscribe((e: any) => this.debounceClick.emit(e));
  }

  /**
   * Cleans up any resources used by the directive.
   */
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  /**
   * Event listener for the click event.
   * Prevents the default click behavior and emits the debounced click event.
   * @param event - The click event object.
   */
  @HostListener('click', ['$event'])
  clickEvent(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }
}
